import { render, staticRenderFns } from "./employeeTransferHis.vue?vue&type=template&id=6744b51c&scoped=true"
import script from "./employeeTransferHis.vue?vue&type=script&lang=js"
export * from "./employeeTransferHis.vue?vue&type=script&lang=js"
import style0 from "./employeeTransferHis.vue?vue&type=style&index=0&id=6744b51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6744b51c",
  null
  
)

export default component.exports